import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>PoyntHQ dashboard</h1>
			<p className='project-popup__description '>
				Poynt HQ is a remote control for Payment Terminals, e.g., in restaurants. It
				lets business owners monitor real-time sales data, create or refund
				transactions, and get powerful insights about their customers and business.{' '}
				<br />I participated in the team development of the PoyntHQ dashboard. The
				server part of the dashboard was implemented on Node.js + GraphQl and
				PostgreSQL technologies. The client-side includes integrations with business
				analytics and third-party tools for displaying data.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						React.js, Typescript, Node.js + express, GraphQl, PostgresQL
					</span>
				</p>
			</div>
			<div className='project-popup__images '>
				<p className='image-description '>Monthly statistics</p>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/poynthq/2.webp',
						backupImage: './media/projects/poynthq/2.jpg',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='snake-image1' />}
				</ProgressiveImage>
				<p className='image-description '>Sales breakdown diagram</p>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/poynthq/1.webp',
						backupImage: './media/projects/poynthq/1.jpg',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='snake-image1' />}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
